import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-policychange-common-react';
import CoveragesPage from './pages/Coverages/CoveragesPage';
import MortgageePage from './pages/Mortgagee/MortgageePage';
import PCHOQuotePage from './pages/Quote/QuotePage';
import PolicyChangesPage from './pages/PolicyChanges/PolicyChangesPage';
import ValuablesPage from './pages/Valuables/ValuablesPage';
import HOBillingDetailsPagePolChange from '../ml-capability-policychange-common-react/pages/BillingDetails/BillingDetailsPagePolChange';
import HOAddressPagePolChange from '../ml-capability-policychange-common-react/pages/Address/AddressPagePolChange';
import HOAffiliationPagePolChange from '../ml-capability-policychange-common-react/pages/Affiliation/AffiliationPagePolChange';
import HODiscountPagePolChange from '../ml-capability-policychange-common-react/pages/Discounts/DiscountsPagePolChange';
import HOPropertyDetailsPolChange from './pages/PropertyDetails/PropertyDetailsPolChangePage';

import './HOPolicyChange.messages';
import AdditionalPolicyInfoPolChange from '../ml-capability-policychange-common-react/pages/AdditionalPolicyInfo/AdditionalPolicyInfoPolChange';
import HOConfirmationPolChange from '../ml-capability-policychange-common-react/pages/Confirmation/ConfirmationPolChange';

setComponentMapOverrides(
    {
        PolicyChangesPage: { component: 'PolicyChangesPage' },
        ValuablesPage: { component: 'ValuablesPage' },
        MortgageePage: { component: 'MortgageePage' },
        CoveragesPage: { component: 'CoveragesPage' },
        PCHOQuotePage: { component: 'PCHOQuotePage' },
        HOBillingDetailsPagePolChange: { component: 'HOBillingDetailsPagePolChange'},
        HOAddressPagePolChange: { component: 'HOAddressPagePolChange' },
        HOAffiliationPagePolChange: { component: 'HOAffiliationPagePolChange'},
        HODiscountPagePolChange: { component: 'HODiscountPagePolChange'},
        AdditionalPolicyInfoPolChange: { component: 'AdditionalPolicyInfoPolChange' },
        HOPropertyDetailsPolChange: { component: 'HOPropertyDetailsPolChange' },
        HOConfirmationPolChange: { component: 'HOConfirmationPolChange' }

    },
    {
        PolicyChangesPage,
        ValuablesPage,
        MortgageePage,
        CoveragesPage,
        PCHOQuotePage,
        HOBillingDetailsPagePolChange,
        HOAddressPagePolChange,
        HOAffiliationPagePolChange,
        HODiscountPagePolChange,
        AdditionalPolicyInfoPolChange,
        HOPropertyDetailsPolChange,
        HOConfirmationPolChange
    }
);
// eslint-disable-next-line import/prefer-default-export
export { default as HOPolicyChangeWizard } from './HOPolicyChangeWizard';
export { default as HOPolicyChangeMessages } from './HOPolicyChange.messages';
